module.exports = __webpack_public_path__ + "img/2025-09-19a_2.ac82b1c5.jpg";